export default __webpack_public_path__ + "static/media/slider-7.f1f3c6f8.png";